import {
    MANAGE_ORGANIZATION_PAGE,
    ORGANIZATION_EDIT_MEMBER,
    ORGANIZATION_NEW_MEMBER,
    ORGANIZATION_USERS
} from 'hooks/usePageRoutes/constants';

export const ORGANIZATION_EDIT_ROUTE = `${MANAGE_ORGANIZATION_PAGE}/edit`;

export const ORGANIZATION_NEW_ROUTE = `${MANAGE_ORGANIZATION_PAGE}/new`;

export const EDIT_PANEL_ROUTE_PREFIXES = [ORGANIZATION_EDIT_ROUTE, ORGANIZATION_NEW_ROUTE];

export const PATH_SEPARATOR = '/';

// The member detail is a place in the users section, so the path names it: the
// member route itself, and the certification panels that keep the member on screen.
export const MEMBER_ROUTE_PREFIXES = [
    ORGANIZATION_USERS,
    ORGANIZATION_EDIT_MEMBER,
    ORGANIZATION_NEW_MEMBER
];

export const getOpenedMemberId = (pathname: string): string | null => {
    const matchedPrefix = MEMBER_ROUTE_PREFIXES.find(routePrefix =>
        pathname.startsWith(`${routePrefix}${PATH_SEPARATOR}`)
    );

    if (!matchedPrefix) {
        return null;
    }

    const [memberId] = pathname
        .slice(matchedPrefix.length + PATH_SEPARATOR.length)
        .split(PATH_SEPARATOR);

    return memberId || null;
};

// The member opens in the edit panel like every other flow in this workspace, so
// the member route counts as an open panel alongside the edit and create routes.
export const getIsEditPanelOpen = (pathname: string): boolean =>
    EDIT_PANEL_ROUTE_PREFIXES.some(routePrefix => pathname.startsWith(routePrefix)) ||
    getOpenedMemberId(pathname) !== null;
